import { render } from "./PromptsManager.vue?vue&type=template&id=0896253c&scoped=true"
import script from "./PromptsManager.vue?vue&type=script&lang=js"
export * from "./PromptsManager.vue?vue&type=script&lang=js"

import "./PromptsManager.vue?vue&type=style&index=0&id=0896253c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0896253c"]])

export default __exports__